export enum OrderEstrategyTypeEnum {
  POSITION = 'POSITION',
  DAYTRADE = 'DAYTRADE',
}
